(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cocooning-withdrawal"]) return;
  try {
    
document.querySelectorAll('.co-withdraw').forEach(root=>{
const form=root.querySelector('form'),review=root.querySelector('[data-review]'),confirm=root.querySelector('[data-confirm]'),summary=root.querySelector('[data-summary]');
if(!form||!review||!confirm)return;
review.hidden=false;confirm.hidden=true;
review.addEventListener('click',()=>{if(!form.reportValidity())return;root.querySelector('[data-summary-text]').textContent=[form.elements['contact[name]'].value,form.elements['contact[email]'].value,form.elements['contact[reference_commande]'].value,form.elements['contact[articles]'].value].join(' · ');summary.hidden=false;confirm.hidden=false;review.hidden=true;form.dataset.reviewed='true';confirm.focus();});
root.querySelector('[data-edit]').addEventListener('click',()=>{summary.hidden=true;confirm.hidden=true;review.hidden=false;delete form.dataset.reviewed;form.elements['contact[name]'].focus();});
form.addEventListener('input',()=>{if(form.dataset.reviewed){summary.hidden=true;confirm.hidden=true;review.hidden=false;delete form.dataset.reviewed;}});
form.addEventListener('submit',event=>{if(form.dataset.reviewed!=='true'){event.preventDefault();review.click();}});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
